export const getBoundingClientRect = element => {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    width: rect.width,
    height: rect.height,
    x: rect.x,
    y: rect.y
  };
};

export const debug = true;



export const styles = { //DEFAULT STYLES (true)
  fontSize: '14px',
  // fontFamily: '"Graphik cy web", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',

  backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',
  cardWidth: 240,

  paddings: 16,
  borderRadius: 2,
  cardContrast: 1,
  psWidth: 640,

  boxShadow: '0 5px 12px 0px rgba(0,0,0,0.2)',
  transitionTime: '0.3s',
  transitionEasing: 'ease-in-out',
  transition: 'all 0.3s ease-in-out',
  transitionStyle: '0.3s ease-in-out',
  fontFamily: '"Graphiklcg", "Roboto", "Helvetica Neue", "Arial"',
  // fontFamily: '"Comic Sans"',
}


export const themeSecure = {
  id: 'moon',
  name: 'Moon',
  colorText: "#000000",
  colorAccent: "#000000",
  colorBg: "#FFFFFF",
  colorAccentText: "#FFFFFF",
  borderRadius: 4
}


export const themes = [
  // {
  //   id: 'magenta',
  //   name: 'Magenta Dark',
  //   colorText: '#D6E0E7',
  //   colorAccent: '#FF005B',
  //   colorAccentText: '#F6FAFF',
  //   colorBg: '#011627',
  // },

  {
    id: 'magenta',
    name: 'Magenta Dark',
    colorText: '#D6E0E7',
    colorAccent: '#FF005B',
    colorBg: '#011627',
    colorAccentText: '#F6FAFF',
  },

  {
    id: 'pop',
    name: 'Pop_Art',
    colorText: "#ffff00",
    colorAccent: "#FF0000",
    colorBg: "#1d2458",
    colorAccentText: "white",
  },
  {
    id: 'arizona',
    name: 'Arizona Green Tea',
    colorText: "#000000",
    colorAccent: "#ff0098",
    colorBg: "#a4e4d7",
    colorAccentText: "#FFFFFF",

  },
  {
    id: 'wes',
    name: 'Wes Anderson',
    colorText: "#E7C865",
    colorAccent: "#AAD8C8",
    colorBg: "#433446",
    colorAccentText: "black",
  },
  {
    id: 'moon',
    name: 'Moon',
    colorText: "#000000",
    colorAccent: "#FF005B",
    colorBg: "#FFFFFF",
    colorAccentText: "#FFFFFF",
  },
  {
    id: 'iconic',
    name: 'Iconic',
    colorText: '#0079F4',
    colorAccent: '#D2F51D',
    colorBg: '#1d1533',
    colorAccentText: "#000000",
  },

]



export const themesOld = [
  {
    id: "magenta",
    name: "Magenta Dark",
    colorText: "#D6E0E7",
    colorAccent: "#FF005B",
    colorAccentText: "#F6FAFF",
    colorBg: "#011627",

    borderRadius: 8,

    // backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',
    backgroundUrl: false,

    cardWidth: 240,
    cardPadding: 24,

    boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
    transitionTime: "0.3s",
    transitionEasing: "ease-in-out",
    transition: "all 0.3s ease-in-out",
    transitionStyle: "0.3s ease-in-out",
    fontFamily:
      '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
  },

  {
    id: "pop",
    name: "Pop_Art",
    colorText: "#ffff00",
    colorAccent: "#FF0000",
    colorBg: "#000C68",
    colorAccentText: "white",
    borderRadius: 20,

    backgroundUrl:
      "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
    cardWidth: 240,
    cardPadding: 24,
    boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
    transitionTime: "0.3s",
    transitionEasing: "ease-in-out",
    transition: "all 0.3s ease-in-out",
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: "0.3s ease-in-out",
    fontFamily:
      '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
  },
  {
    id: "arizona",
    name: "Arizona Green Tea",
    colorText: "blue",
    colorAccent: "red",
    colorBg: "#40E0D0",
    colorAccentText: "black",
    borderRadius: 10,

    cardWidth: 240,
    cardPadding: 24,
    backgroundUrl:
      "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
    boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
    transitionTime: "0.3s",
    transitionEasing: "ease-in-out",
    transition: "all 0.3s ease-in-out",
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: "0.3s ease-in-out",
    fontFamily:
      '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
  },
  {
    id: "wes",
    name: "Wes Anderson",
    colorText: "#E7C865",
    colorAccent: "#AAD8C8",
    colorBg: "#433446",
    colorAccentText: "#433446",
    borderRadius: 4,

    cardWidth: 240,
    cardPadding: 24,
    backgroundUrl:
      "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
    boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
    transitionTime: "0.3s",
    transitionEasing: "ease-in-out",
    transition: "all 0.3s ease-in-out",
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: "0.3s ease-in-out",
    fontFamily:
      '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
  },
  {
    id: "moon",
    name: "Moon",
    colorText: "#000000",
    colorAccent: "#FF005B",
    colorBg: "#FFFFFF",
    colorAccentText: "#FFFFFF",
    borderRadius: 0,

    // backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',
    backgroundUrl: false,

    cardWidth: 240,
    cardPadding: 24,
    boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
    transitionTime: "0.3s",
    transitionEasing: "ease-in-out",
    transition: "all 0.3s ease-in-out",
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: "0.3s ease-in-out",
    fontFamily:
      '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
  },
  {
    id: "iconic",
    name: "Iconic",
    colorText: "#0079F4",
    colorAccent: "#D2F51D",
    colorBg: "#040A20",
    colorAccentText: "#FFFFFF",
    borderRadius: 3,

    backgroundUrl:
      "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
    cardWidth: 240,
    cardPadding: 24,
    boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
    transitionTime: "0.3s",
    transitionEasing: "ease-in-out",
    transition: "all 0.3s ease-in-out",
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: "0.3s ease-in-out",
    fontFamily:
      '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
  }
];

export const sections = [
  [
    {
      menu: true,
      title: true,
      activeModule: "virtualItems",
      activeGroup: 'first',
      cardWidth: 180,
      pagination: true,
      // template: 'blurred',
      // limit: false,
      theme: null,
      slider: false
    }
  ],
  [
    {
      title: true,
      menu: false,
      activeModule: "virtualItems",
      activeGroup: 'first',
      cardWidth: 214,
      pagination: true,
      template: "blurred",
      theme: {
        id: "pop",
        name: "Pop_Art",
        colorText: "#ffff00",
        colorAccent: "#FF0000",
        colorBg: "#000C68",
        colorAccentText: "white",
        borderRadius: 20,
        backgroundUrl:
          "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
        cardWidth: 240,
        cardPadding: 24,
        cardContrast: 2,

        boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
        transitionTime: "0.3s",
        transitionEasing: "ease-in-out",
        transition: "all 0.3s ease-in-out",
        transitionStyle: "0.3s ease-in-out",
        fontFamily:
          '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
      },
      slider: true,
      limit: 4
    },
    {
      title: true,
      menu: true,
      activeModule: "virtualItems",
      activeGroup: 'first',
      cardWidth: 200,
      template: 'blurred',
      pagination: true,
      theme: {
        id: "wes",
        name: "Wes Anderson",
        colorText: "#E7C865",
        colorAccent: "#AAD8C8",
        colorBg: "#433446",
        colorAccentText: "#433446",
        borderRadius: 4,
        cardWidth: 240,
        cardPadding: 24,
        cardContrast: 2,
        backgroundUrl:
          "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
        boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
        transitionTime: "0.3s",
        transitionEasing: "ease-in-out",
        transition: "all 0.3s ease-in-out",
        transitionStyle: "0.3s ease-in-out",
        fontFamily:
          '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
      },
      slider: false,
      limit: 8
    }
  ],

  // [
  //   {
  //     menu: true,
  //     title: true,
  //     activeModule: 'virtualItems',
  //     activeGroup: 8593,
  //     cardWidth: 180,
  //     // limit: 8,
  //     pagination: true,
  //     template: 'blurred',
  //     slider: true,
  //     theme: null,
  //     // theme: {...themes[0]},
  //   },
  //   {
  //     menu: false,
  //     title: true,
  //     activeModule: 'subscriptions',
  //     activeGroup: 8740,
  //     cardWidth: 180,
  //     limit: 0,
  //   },
  //   {
  //     menu: true,
  //     title: true,
  //     activeModule: 'virtualItems',
  //     activeGroup: 8740,
  //     cardWidth: 180,
  //     pagination: true,
  //     template: 'blurred',
  //     limit: 8,
  //     theme: null,
  //     slider: true,
  //   },
  // ],

  [
    {
      menu: true,
      title: true,
      activeModule: "virtualItems",
      activeGroup: 'first',
      cardWidth: 180,
      pagination: true,
      // template: 'blurred',
      // limit: false,
      theme: null,
      slider: false
    }
  ],

  [
    {
      menu: false,
      title: "Featured",
      activeModule: "virtualItems",
      activeGroup: 'first',
      cardWidth: 200,
      limit: 4,
      pagination: true,
      template: "blurred",
      theme: null,
      slider: true
    },
    {
      menu: true,
      title: true,
      activeModule: "virtualItems",
      activeGroup: 'first',
      cardWidth: 180,
      pagination: false,
      // theme: {...themes[1]},
      theme: null,
      slider: false
    }
    // {
    //   menu: false,
    //   title: true,
    //   activeModule: 'subscriptions',
    //   activeGroup: 8740,
    //   cardWidth: 400,
    //   limit: 0,
    //   theme: null,
    //   slider: false,
    // },
  ],

  [
    {
      menu: false,
      title: true,
      activeModule: "subscriptions",
      cardWidth: 200,
      limit: 0,
      pagination: true,
      template: "blurred",
      theme: null,
      slider: false
    },
    {
      menu: false,
      title: true,
      activeModule: "currency",
      cardWidth: 200,
      limit: 0,
      pagination: true,
      template: "blurred",
      theme: null,
      slider: false
    }
  ],

  [
    {
      menu: false,
      title: "Featured",
      activeModule: "virtualItems",
      activeGroup: 'first',
      cardWidth: 260,
      limit: 4,
      pagination: true,
      template: "blurred",
      theme: { ...themes[4] },
      slider: true
    },
    {
      menu: false,
      title: true,
      activeModule: "virtualItems",
      activeGroup: 8740,
      cardWidth: 200,
      limit: 4,
      template: "blurred",
      pagination: false,
      theme: { ...themes[1] },
      slider: true
    },
    {
      menu: false,
      title: true,
      cardWidth: 250,
      activeModule: "virtualItems",
      activeGroup: 'first',
      template: "blurred",
      limit: 0,
      theme: { ...themes[2] },
      slider: true
    },
    {
      menu: false,
      title: true,
      cardWidth: 250,
      activeModule: "virtualItems",
      activeGroup: 'first',
      template: "blurred",
      limit: 0,
      theme: { ...themes[3] },
      slider: true
    }
  ]
];
